import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import searchTuneModal from './searchTuneModal'
import searchTuneOption from './searchTuneOption'
import customerInfo from './CustomerInfo'
import moreBtnStore from './MoreBtnStore'
import playlistModule from './PlaylistModule'
import musicPlayerModule from './MusicPlayerModule'
import recommendListModule from './RecommendListModule'
import favoriteListModule from './FavoriteListModule'
import artistListModule from './ArtistListModule'
import rankingListModule from './RankingListModule'

Vue.use(Vuex)

/**
 * stateの初期値
 **/
function initialState () {
  return {
    playListCommitFlg: false,
    playlist_a: [],
    playlist_b: [],
    searchResult: [],
    searchOffset: 0,
    searchResultCount: 0,
    // 一回の検索の件数
    perSearchCount: 20,
    selectedTags: [],
    selectedScenes: [],
    selectedTagIdArray: [],
    selectedsceneIdArray: [],
    freeWords: undefined,
    checkPlaylistFlg: true,
    snack_bar: {
      addPlayListDia: false,
      addFavoriteDia: false,
      sendContactDia: false,
      changeInfoDia: false,
      deleteItemDia: false,
      errorDia: false
    },
    isNotExistDuplicationOtherTuneFlag: true,
    transactionId: null // 認証用tokenId
  }
}

const store = new Vuex.Store({
  state: initialState,
  getters: {
    checkTransactionId: state => state.transactionId,
    getSearchResult (state) {
      return state.searchResult
    },
    getPlayListA (state) {
      return state.playlist_a
    },
    getPlayListB (state) {
      return state.playlist_b
    },
    getIsumTuneByPlayListIdAndIndex: (state) => (playListType, index) => {
      const key = 'isum_code'
      switch (playListType) {
        case 1:
          return state.playlist_a[index][key]
        case 2:
          return state.playlist_b[index][key]
      }
    },
    getOtherTuneByPlayListIdAndIndex: (state) => (playListType, index) => {
      const key = 'other_song_name'
      switch (playListType) {
        case 1:
          return state.playlist_a[index][key]
        case 2:
          return state.playlist_b[index][key]
      }
    },
    /**
     * プレイリスト中のISUM楽曲の数を取得
     * @param state
     */
    getIsumTuneInPlayListCount: state => {
      let isumTuneInPlayListCount = 0
      for (let i = 0; i < Object.keys(state.playlist_a).length; i++) {
        if (state.playlist_a[i]['isum_code'] !== undefined && state.playlist_a[i]['isum_code'] != null) {
          isumTuneInPlayListCount++
        }
      }
      for (let i = 0; i < Object.keys(state.playlist_b).length; i++) {
        if (state.playlist_b[i]['isum_code'] !== undefined && state.playlist_b[i]['isum_code'] != null) {
          isumTuneInPlayListCount++
        }
      }
      return isumTuneInPlayListCount
    },
    /**
     * プレイリスト中のその他楽曲の数を取得
     * @param state
     */
    getOtherTuneInPlayListCount: state => {
      let otherTuneInPlayListCount = 0
      for (let i = 0; i < Object.keys(state.playlist_a).length; i++) {
        if (state.playlist_a[i]['other_song_name'] !== undefined && state.playlist_a[i]['other_song_name'] != null) {
          otherTuneInPlayListCount++
        }
      }
      for (let i = 0; i < Object.keys(state.playlist_b).length; i++) {
        if (state.playlist_b[i]['other_song_name'] !== undefined && state.playlist_b[i]['other_song_name'] != null) {
          otherTuneInPlayListCount++
        }
      }
      return otherTuneInPlayListCount
    },
    /**
     * 指定したプレイリスト楽曲に紐づいているコメントを取得する
     */
    getCommentText: (state) => (playListType, index) => {
      if (parseInt(playListType) === 1) {
        return state.playlist_a[index]['comment']
      } else if (parseInt(playListType) === 2) {
        return state.playlist_b[index]['comment']
      }
    },
    /**
     * ISUM情報をstoreから取得
     * @returns {Function}
     */
    getIsumTuneInfo: (state) => (playListType, index) => {
      let playList = ''
      if (parseInt(playListType) === 1) {
        playList = state.playlist_a[index]
      } else if (parseInt(playListType) === 2) {
        playList = state.playlist_b[index]
      }
      return {
        isumCode: playList['isum_code'] ? playList['isum_code'] : null,
        isumType: playList['isum_type'] ? playList['isum_type'] : null,
        isumTune: playList['isum_song_name'] ? playList['isum_song_name'] : null,
        isumArtist: playList['isum_artist_name'] ? playList['isum_artist_name'] : null
      }
    },
    /**
     *  その他の楽曲情報をstoreから取得
     * @param state
     * @returns {Function}
     */
    getOtherTuneInfo: (state) => (playListType, index) => {
      if (parseInt(playListType) === 1) {
        return {
          otherArtistName: state.playlist_a[index]['other_artist_name'],
          otherSongName: state.playlist_a[index]['other_song_name']
        }
      } else if (parseInt(playListType) === 2) {
        return {
          otherArtistName: state.playlist_b[index]['other_artist_name'],
          otherSongName: state.playlist_b[index]['other_song_name']
        }
      }
    }
  },
  modules: {
    artistListModule,
    searchTuneModal,
    searchTuneOption,
    customerInfo,
    favoriteListModule,
    moreBtnStore,
    musicPlayerModule,
    playlistModule,
    recommendListModule,
    rankingListModule
  },
  mutations: {
    /**
     * tokenIdをstoreに保管するメソッド
     **/
    updateStateTransactionId: function (state, transactionId) {
      state.transactionId = transactionId
    },
    /**
     * 楽曲検索結果を保持
     **/
    updateSearchResult: function (state, musicData) {
      state.searchResult = musicData
      // 検索結果件数を配列の中から取得
      if (state.searchResult.length > 0) {
        state.searchResultCount = state.searchResult[0].results_count
      } else {
        state.searchResultCount = 0
      }
    },
    /**
     * 進行プレイリストを保持
     **/
    updateStatePlayListA: function (state, playlist) {
      state.playlist_a = playlist
    },
    /**
     * 寒暖プレイリストを保持
     **/
    updateStatePlayListB: function (state, playlist) {
      state.playlist_b = playlist
    },
    /**
     * 検索に利用したシーンを保持
     **/
    updateStateSelectedScenes: function (state, scenes) {
      state.selectedScenes = scenes
    },
    /**
     * 検索に利用したタグを保持
     **/
    updateStateSelectedTags: function (state, tags) {
      state.selectedTags = tags
    },
    /**
     * 検索に利用したシーンIDを保持
     **/
    updateStateSelectedSceneIdArray: function (state, array) {
      state.selectedsceneIdArray = array
    },
    /**
     * 検索に利用したタグIDを保持
     **/
    updateStateSelectedTagIdArray: function (state, array) {
      state.selectedTagIdArray = array
    },
    /**
     * 検索に利用したフリーワードを保持
     **/
    updateStateFreeWords: function (state, freeWords) {
      state.freeWords = freeWords
    },
    /**
     * 検索に利用したcheckPlaylistFlgを保持
     **/
    updateStateCheckPlaylistFlg: function (state, flg) {
      state.checkPlaylistFlg = flg
    },
    /**
     * 検索に利用したoffsetを保持
     **/
    updateStateSearchOffset: function (state, offset) {
      state.searchOffset = offset
    },
    /**
     * stateの値を初期値に戻す
     **/
    resetState (state) {
      const initialStates = initialState()
      Object.keys(initialStates).forEach(key => {
        state[key] = initialStates[key]
      })
    },
    updateIsNotExistDuplicationOtherTuneFlag (state, isNotExistDuplicationOtherTuneFlag) {
      state.isNotExistDuplicationOtherTuneFlag = isNotExistDuplicationOtherTuneFlag
    },
    updateIsNotExistDuplicationIsumTuneFlag (state, isNotExistDuplicationIsumTuneFlag) {
      state.isNotExistDuplicationIsumTuneFlag = isNotExistDuplicationIsumTuneFlag
    }
  },
  actions: {
    updateIsNotExistDuplicationOtherTuneFlag (context, isNotExistDuplicationOtherTuneFlag) {
      this.commit('updateIsNotExistDuplicationOtherTuneFlag', isNotExistDuplicationOtherTuneFlag)
    },
    updateIsNotExistDuplicationIsumTuneFlag (context, isNotExistDuplicationIsumTuneFlag) {
      this.commit('updateIsNotExistDuplicationIsumTuneFlag', isNotExistDuplicationIsumTuneFlag)
    },
    resetMusicData () {
      this.commit('updateSearchResult', {})
    }
  },
  plugins: [
    // ページリロードしても値を保持するものは以下に追記
    createPersistedState(
      {
        key: 'storage',
        paths: ['transactionId', 'searchResult', 'selectedTags', 'selectedScenes', 'selectedTagIdArray', 'selectedsceneIdArray', 'freeWords', 'checkPlaylistFlg', 'searchResultCount'],
        storage: window.sessionStorage
      })
  ]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js